import {createAction} from 'redux-actions';

const PREFIX = 'DIRECTORY_';

export const getDirectory = createAction(`${PREFIX}GET_DIRECTORY`);
export const getDirectorySuccess = createAction(
  `${PREFIX}GET_DIRECTORY_SUCCESS`,
  (payload) => payload,
);
export const getDirectoryFailure = createAction(
  `${PREFIX}GET_DIRECTORY_FAILURE`,
  (payload) => payload,
);
